/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.43.0(94c055bcbdd49f04a0fa15515e848542a79fb948)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.de", {
	"vs/base/common/platform": [
		"_",
	],
	"vs/editor/common/languages": [
		"Array",
		"Boolescher Wert",
		"Klasse",
		"Konstante",
		"Konstruktor",
		"Enumeration",
		"Enumerationsmember",
		"Ereignis",
		"Feld",
		"Datei",
		"Funktion",
		"Schnittstelle",
		"Schlüssel",
		"Methode",
		"Modul",
		"Namespace",
		"NULL",
		"Zahl",
		"Objekt",
		"Operator",
		"Paket",
		"Eigenschaft",
		"Zeichenfolge",
		"Struktur",
		"Typparameter",
		"Variable",
		"{0} ({1})",
	]
});